var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.0012 13.7143",
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart--reward-social-rating-media-heart-it-like-favorite-love"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.58022 0.0109354C5.70209 0.0938154 6.87099 0.648353 7.99164 1.76802C9.11337 0.651621 10.285 0.100433 11.4095 0.0196897C12.6788 -0.0714543 13.8002 0.444078 14.6092 1.25722C16.2007 2.85681 16.6856 5.74767 14.6783 7.72955L14.665 7.74223L8.37915 13.5622C8.16009 13.7651 7.82179 13.7651 7.60272 13.5622L1.31682 7.74223C1.31105 7.73689 1.3054 7.73144 1.29986 7.72587C-0.678284 5.73676 -0.195392 2.8459 1.38947 1.24627C2.19556 0.432673 3.31326 -0.0826623 4.58022 0.0109354Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "heart.ce3f78e2518972a5a1b76389a8d4d08b.svg";